import React from 'react';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { SourceMetricRow, SalesActivityTimeRange } from '../../utils/leadAnalytics';

interface Props {
  rows: SourceMetricRow[];
  timeRange: SalesActivityTimeRange;
  onClose: () => void;
}

const LeadsBySourcePopover: React.FC<Props> = ({ rows, timeRange, onClose }) => {
  const navigate = useNavigate();

  return (
    <div className="fin-modal-overlay" onClick={onClose}>
      <div
        className="fin-modal"
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Leads by source"
      >
        <div className="fin-modal-header">
          <h3>Leads by source</h3>
          <button type="button" className="fin-modal-close" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </div>
        <div className="fin-modal-body">
          <table className="fin-forecast-table">
            <thead>
              <tr>
                <th>Source</th>
                <th>Leads</th>
                <th>Deals</th>
                <th>Conv.</th>
                <th>Win %</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(row => (
                <tr
                  key={row.source}
                  className="sa-modal-row-clickable"
                  onClick={() => {
                    navigate('/', {
                      state: { sourceFilter: row.source, dateRange: timeRange },
                    });
                    onClose();
                  }}
                >
                  <td>
                    <span className="sa-source-dot" style={{ background: row.color }} />
                    {row.source}
                  </td>
                  <td>{row.leadCount}</td>
                  <td>{row.dealCount}</td>
                  <td>{row.conversionRate.toFixed(0)}%</td>
                  <td>{row.winRate.toFixed(0)}%</td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <p className="sa-muted">No leads in this range.</p>}
        </div>
      </div>
    </div>
  );
};

export default LeadsBySourcePopover;
